import { render } from "./CreateNewParticipant.vue?vue&type=template&id=4aaed7d2&scoped=true"
import script from "./CreateNewParticipant.vue?vue&type=script&lang=js"
export * from "./CreateNewParticipant.vue?vue&type=script&lang=js"

import "./CreateNewParticipant.vue?vue&type=style&index=0&id=4aaed7d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aaed7d2"]])

export default __exports__